import React, { useEffect } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';

import { Layout } from './design';
import Users from './users';
import Dealership from './design/manage-control/components/dealership';
import ManageControl from './design/manage-control';
// import DomainsWhitelist from './../design/domainsWhitelist';
import DomainWhitelist from './design/manage-control/components/domainWhitelist';
import App from './app';
import Login from './login';
import ForgotPassword from './forgotPassword';
import Registration from './registration';
import UpdatePassword from './updatePassword';
import UserApproval from './userApproval';
import BulkUpload from './bulkUpload';
import ReferralForm from './referral';
import DefectManagement from './defectManagement';
import { PrivateRoute, PublicRoute } from './routeHandler';
import {
  pages,
  defaultLocale,
  addLocale,
  getPathVariables,
  getUrlWithoutLocale,
  localeEn,
  localeFr
} from './misc';
import Orders from './orders';

import history from './history';
import { useLocaleContext } from './context/LocaleContext';
import { useLocalizedStringsContext } from './context/LocalizedStringsContext';
import Help from './help';
import ThankYou from './help/ThankYou';
import HowToVideos from './help/HowToVideos';
import ReportAnIssue from './help/ReportAnIssue';
import Reporting from './reporting';
import FiltersContextProvider from './context/FiltersContext';
import TwoFactorAuthentication from './2fa';
import Success from './signContract/success';
import SuccessSOW from './signContract/successSOW';
import SuccessCS from './signContract/successCS'
import Expired from './signContract/expired';
import { SignContract, SignContractOCDR, SignContractCS, SignContractSOW } from './signContract';
import SuccessOCDR from './signContract/successOCDR';
import ProductCatalogueDashboard from './productCatalogueDashboard';

const Routes = () => {
  const {
    location: { pathname, search }
  } = window;
  const locale = useLocaleContext();
  const addLocaleToUrl = addLocale(locale);
  if (locale && ![localeEn, localeFr].includes(locale)) {
    window.location = addLocale(defaultLocale)(pathname.concat(search));
  }

  useEffect(() => {
    const oldLocale = getPathVariables(window.location.pathname)[0];

    if (oldLocale && oldLocale !== locale) {
      const urlWithoutLocale = getUrlWithoutLocale(oldLocale)(
        window.location.pathname
      );
      const url =
        urlWithoutLocale !== pages.HOME
          ? addLocaleToUrl(`/${urlWithoutLocale}${search}`)
          : addLocaleToUrl('/');
      history.push(url);
    }
  }, [locale]);

  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels: { TELUS_HEADING }
      }
    }
  } = localizedStrings;

  useEffect(() => {
    document.title = TELUS_HEADING;
  }, [localizedStrings]);

  return (
    <Router history={history}>
      <FiltersContextProvider>
        <Layout locale={locale} pathname={pathname}>
          <Switch>
            <Route
              path={pages.HOME}
              render={() => <Redirect to={addLocale(locale)(pages.HOME)} />}
              exact
            />
            <Redirect from="/login" to={addLocaleToUrl('/login')} />
            <Redirect
              from="/registration"
              to={addLocaleToUrl('/registration')}
            />
            <Redirect
              from="/forgot-password"
              to={addLocaleToUrl('/forgot-password')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract/success')}
              component={Success}
            />
            <Redirect
              from="/sign-contract/success"
              to={addLocaleToUrl('/sign-contract/success')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-sow/success')}
              component={SuccessSOW}
            />
            <Redirect
              from="/sign-contract-sow/success"
              to={addLocaleToUrl('/sign-contract-sow/success')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-ocdr/success')}
              component={SuccessOCDR}
            />
            <Redirect
              from="/sign-contract-ocdr/success"
              to={addLocaleToUrl('/sign-contract-ocdr/success')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-cs/success')}
              component={SuccessCS}
            />
            <Redirect
              from="/sign-contract-cs/success"
              to={addLocaleToUrl('/sign-contract-cs/success')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract/expired')}
              component={Expired}
            />
            <Redirect
              from="/sign-contract/expired"
              to={addLocaleToUrl('/sign-contract/expired')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-sow/expired')}
              component={Expired}
            />
            <Redirect
              from="/sign-contract-sow/expired"
              to={addLocaleToUrl('/sign-contract-sow/expired')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-ocdr/expired')}
              component={Expired}
            />
            <Redirect
              from="/sign-contract-ocdr/expired"
              to={addLocaleToUrl('/sign-contract-ocdr/expired')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-cs/expired')}
              component={Expired}
            />
            <Redirect
              from="/sign-contract-cs/expired"
              to={addLocaleToUrl('/sign-contract-cs/expired')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract')}
              component={SignContract}
            />
            <Redirect
              from="/sign-contract/:token"
              to={addLocaleToUrl('/sign-contract')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-sow')}
              component={SignContractSOW}
            />
            <Redirect
              from="/sign-contract-sow/:token"
              to={addLocaleToUrl('/sign-contract')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-ocdr')}
              component={SignContractOCDR}
            />
            <Redirect
              from="/sign-contract-ocdr/:token"
              to={addLocaleToUrl('/sign-contract-ocdr')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract-cs')}
              component={SignContractCS}
            />
            <Redirect
              from="/sign-contract-cs/:token"
              to={addLocaleToUrl('/sign-contract-cs')}
            />
            <Redirect from="/orders" to={addLocaleToUrl('/orders')} />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/orders')}
              component={Orders}
              locale={locale}
            />
            <Redirect
              from="/users/:userId"
              to={addLocaleToUrl('/users/:userId')}
            />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/defects')}
              component={DefectManagement}
              locale={locale}
            />
            <Redirect from="/defects" to={addLocaleToUrl('/defects')} />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/defects/:defectId')}
              component={DefectManagement}
              locale={locale}
            />
            <Redirect
              from="/defects/:defectId"
              to={addLocaleToUrl('/defects/:defectId')}
            />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/users/:userId')}
              component={Users}
              locale={locale}
            />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/referrals/Referral_Form/')}
              component={ReferralForm}
              locale={locale}
            />
            <Redirect from="/users" to={addLocaleToUrl('/users')} />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/users')}
              component={Users}
              locale={locale}
            />
            <Redirect from="/dealerships" to={addLocaleToUrl('/dealerships')} />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/dealerships')}
              component={Dealership}
              locale={locale}
            />
            <Redirect
              from="/manage-control/:controlId"
              to={addLocaleToUrl('/manage-control/:controlId')}
            />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/manage-control/:tabName')}
              component={ManageControl}
              locale={locale}
            />
            <Redirect from="/domains" to={addLocaleToUrl('/domains')} />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/domains')}
              component={DomainWhitelist}
              locale={locale}
            />
            <Redirect
              from="/forgot-password"
              to={addLocaleToUrl('/forgot-password')}
            />
            <PublicRoute
              path={addLocaleToUrl('/forgot-password')}
              component={ForgotPassword}
            />
            <Redirect
              from="/update-password"
              to={addLocaleToUrl('/update-password')}
            />
            <PublicRoute
              path={addLocaleToUrl('/update-password')}
              component={UpdatePassword}
            />
            <Redirect from="/bulk-upload" to={addLocaleToUrl('/bulk-upload')} />
            <PrivateRoute
              path={addLocaleToUrl('/bulk-upload')}
              component={BulkUpload}
              locale={locale}
            />
            <Redirect
              from="/report-an-issue/success"
              to={addLocaleToUrl('/report-an-issue/success')}
            />
            <PrivateRoute
              path={addLocaleToUrl('/report-an-issue/success')}
              locale={locale}
              component={ThankYou}
            />
            <Redirect
              from="/report-an-issue"
              to={addLocaleToUrl('/report-an-issue')}
            />
            <PrivateRoute
              path={addLocaleToUrl('/report-an-issue')}
              component={ReportAnIssue}
              locale={locale}
            />
            <Redirect
              from="/confirmation"
              to={addLocaleToUrl('/confirmation')}
            />
            <Route
              path={addLocaleToUrl('/confirmation')}
              component={UserApproval}
            />
            <PublicRoute
              path={addLocaleToUrl('/registration')}
              component={Registration}
            />
            <Route
              path={addLocaleToUrl('/help')}
              locale={locale}
              component={Help}
            />
            <Route
              path={addLocaleToUrl('/how-to-videos')}
              locale={locale}
              component={HowToVideos}
            />
            <Route
              path={addLocaleToUrl('/wireless/Reporting')}
              locale={locale}
              component={Reporting}
            />
            <PublicRoute
              path={addLocaleToUrl('/two-factor/verify')}
              component={TwoFactorAuthentication}
            />
            <Redirect
              from="/two-factor/verify"
              to={addLocaleToUrl('/two-factor/verify')}
            />
            <PublicRoute path={addLocaleToUrl('/login')} component={Login} />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/product-catalogue-dashboard')}
              component={ProductCatalogueDashboard}
              locale={locale}
            />
            <Redirect
              from="/product-catalogue-dashboard"
              to={addLocaleToUrl('/product-catalogue-dashboard')}
            />
            <PrivateRoute component={App} locale={locale} />
          </Switch>
        </Layout>
      </FiltersContextProvider>
    </Router>
  );
};

export default Routes;
